import './ContentPage.css';
import Footer from '../components/Footer.js'; 

const Future = ({ title, content }) => {
  return (
    <div>
    <div className="content-page">
      <section className="content-hero">
        <h1 className="hero-title">Future Outlook</h1>
        <div className="hero-decor"></div>
      </section>

      <section className="content-section">
        <div className="content-card reveal active">
          <div className="text-container">
            <p className="content-text">Strategically positioned to address challenges from a liberalized and globalized working environment.

Actively establishing links with international legal firms and financial advisors.</p>
          </div>
          <div className="interactive-element">
            <div className="hover-circle"></div>
            <div className="hover-circle"></div>
          </div>
        </div>
      </section>

    </div>
            <Footer />
    </div>
  );
};

export default Future;